import {
    AbstractPopupMenuProvider,
    PopupMenuProviderType,
} from './AbstractPopupMenuProvider';

class PopupReplaceMenuProvider extends AbstractPopupMenuProvider {
    protected getPopupMenuType() {
        return PopupMenuProviderType.Replace;
    }
}

export default PopupReplaceMenuProvider;
